import { useMutation } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { getPointCentralStatusQueryKey } from './get-point-central-status'

type UpdatePointCentralConnectionRequest = {
  buildingId: number
  haiku: string
  password: string
  username: string
}

const updatePointCentralConnection = async (data: UpdatePointCentralConnectionRequest) => {
  const { buildingId, ...body } = data
  const response = await integrationAPI.post(
    `/building/${buildingId}/point-central/integration`,
    body,
  )
  return response.data
}

export const useUpdatePointCentralConnection = () =>
  useMutation({
    mutationFn: updatePointCentralConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getPointCentralStatusQueryKey({ buildingId: variables.buildingId })])
    },
  })
